import React, { useState, useEffect } from 'react';

import { useQuery, useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import FormContainer from '../../../../FormContainer';

import usePrincipalPaymentForm from '../../../../../../forms/loan/principalPayment';
import LoanService from '../../../../../../services/LoanService';
import { useUiContext } from '../../../../../../context/UiContext';
import BorrowerService from '../../../../../../services/BorrowerService';

export default function CreatePrincipalPayment({ loanId, loan }) {
  const [readOnly, setReadOnly] = useState(true);

  const navigate = useNavigate();

  // Prevent the form from auto focusing on page load
  useEffect(() => {
    setTimeout(() => {
      setReadOnly(false);
    }, 100);
  }, []);

  const primaryBorrower = loan?.borrowers?.find(
    (borrower) => borrower.position === 'primary'
  );

  const { data: borrower } = useQuery({
    queryKey: ['borrower', primaryBorrower?.borrower_id],
    queryFn: () => BorrowerService.getBorrower(primaryBorrower.borrower_id),
    enabled: !!primaryBorrower,
  });

  const { showToast } = useUiContext();

  const { mutate: createPrincipalPayment, isPending } = useMutation({
    mutationFn: (formValues) =>
      LoanService.createPrincipalPayment({
        loanId,
        formValues,
      }),
    onSuccess: () => {
      showToast({
        text: 'Principal payment applied',
        type: 'success',
      });
      navigate(`/loans/${loanId}?tab=Schedule`);
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const form = usePrincipalPaymentForm(
    createPrincipalPayment,
    loan?.bank_account_id,
    borrower?._bank_accounts
  );

  return (
    <div className="mb-10">
      <FormContainer
        readOnly={readOnly}
        form={form}
        titleStyle="text-xl"
        noBillComId
        isSubmitting={isPending}
      />
    </div>
  );
}
